import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=58410cbe&scoped=true&"
import script from "./Select.vue?vue&type=script&lang=js&"
export * from "./Select.vue?vue&type=script&lang=js&"
import style0 from "./Select.vue?vue&type=style&index=0&id=58410cbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58410cbe",
  null
  
)

export default component.exports